module.exports = __webpack_public_path__ + "static/media/insights_process1.2e309d93.png";